module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/steps-phone-0152614a9cf3f21048bfc0a4e90b3cf4.png";